"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenMarketRepository = void 0;
const interfaces_1 = require("@build-5/interfaces");
const rxjs_1 = require("rxjs");
const Config_1 = require("../../Config");
const fetch_utils_1 = require("../../fetch.utils");
const CrudRepository_1 = require("../CrudRepository");
const GetTokenPriceGrouped_1 = require("../groupGet/GetTokenPriceGrouped");
const GetTokenPriceGroupedLive_1 = require("../groupGet/GetTokenPriceGroupedLive");
class TokenMarketRepository extends CrudRepository_1.CrudRepository {
    constructor(env) {
        super(env || Config_1.Build5Env.PROD, interfaces_1.PublicCollections.TOKEN_MARKET);
        /**
         * Returns the current market price for a token
         * @param token - Token id
         * @returns
         */
        this.getTokenPrice = (token) => this.getTokenPriceGrouped.get(token);
        /**
         * Returns the current market price for a token live
         * @param token - Token id
         * @returns
         */
        this.getTokenPriceLive = (token) => (0, rxjs_1.from)(this.getTokenPriceGroupedLive.get(token)).pipe((0, rxjs_1.switchMap)((inner) => inner), (0, rxjs_1.map)((r) => r || { id: token, price: 0, usdPrice: 0 }));
        /**
         * Returns the current market price for a token in USD
         * @param token - Token id
         * @returns
         */
        this.getTokenPriceInUsd = async (token) => {
            const response = await (0, fetch_utils_1.wrappedFetch)((0, Config_1.getTokenPriceUrl)(this.env), { token });
            return response.usdPrice;
        };
        this.getBidsLive = (token, type, status, startAfter) => {
            const params = {
                collection: this.col,
                fieldName: ['token', 'type', 'status'],
                fieldValue: [token, type, status],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['price'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
        this.getMemberBidsLive = (token, member, type, startAfter) => {
            const params = {
                collection: this.col,
                fieldName: ['token', 'owner', 'type'],
                fieldValue: [token, member, type],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
        this.getTokenPriceGroupedLive = new GetTokenPriceGroupedLive_1.GetTokenPriceGroupedLive(this.env, this.col);
        this.getTokenPriceGrouped = new GetTokenPriceGrouped_1.GetTokenPriceGrouped(this.env, this.col);
    }
}
exports.TokenMarketRepository = TokenMarketRepository;
